<template>
  <div>
    <!-- 协议链接 -->
    <span class="agreement-link" @click.stop="showPopup">{{
      $t("common.achAuthorization")
    }}</span>

    <!-- 使用van-popup展示授权协议 -->
    <van-popup
      v-model="popupVisible"
      round
      :position="position"
      :isPhone="isPhone"
      :style="{
        height: isPhone ? '320px' : '320px',
        width: isPhone ? '300px' : '380px'
      }"
      closeable
      close-icon="close"
      @closed="handlePopupClosed"
      @click-overlay="handleOverlayClick"
      @click-close-icon="handleCloseIconClick"
    >
      <div class="agreement-popup">
        <!-- <div class="agreement-title">授权</div> -->
        <div
          class="agreement-content"
          :style="{ fontSize: isPhone ? '12px' : '14px' }"
        >
          By providing your bank account details and confirming this payment,
          you authorize Think Academy US to initiate a single electronical debit
          in the amount of $ {{ amount }} from the bank account on record via
          ACH, and, if necessary, electronically credit your account to correct
          erroneous debits. You certify that you are either the holder of, or an
          authorized signatory on, the bank account.
        </div>
        <!-- <div class="agreement-btn" @click="agreeAndClose">我已阅读并同意</div> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import indexMixin from "@/mixins/index";
export default {
  name: "AgreementPopup",
  props: {
    position: {
      type: String,
      default: "center"
    },
    isPhone: {
      type: Boolean,
      default: false
    },
    amount: {
      type: String,
      default: ""
    },
    primaryColor: {
      type: String,
      default: "#ffaa0a"
    }
  },
  mixins: [indexMixin],
  data() {
    return {
      popupVisible: false,
      hasAgreed: false
    };
  },
  methods: {
    /**
     * 显示协议弹窗
     */
    showPopup() {
      // 重置hasAgreed状态，为新的弹窗交互做准备
      this.popupVisible = true;
      this.reportLog({
        eventId: "OPENAGREEMENT_subscription",
        msg: ""
      });
    },

    /**
     * 同意协议并关闭弹窗
     */
    agreeAndClose() {
      console.log('用户点击了"我已阅读并同意"按钮');
      // 标记用户已通过点击按钮同意协议
      this.hasAgreed = true;
      console.log("设置hasAgreed=true，表示用户已同意协议");

      console.log("即将触发agreement-confirmed事件");
      this.$emit("agreement-confirmed");
      console.log("已触发agreement-confirmed事件");
      this.popupVisible = false;

      // 添加日志记录
      this.reportLog({
        eventId: "AGREEMENT_CONFIRM_subscription",
        payCode: "ACH"
      });
    },

    /**
     * 处理弹窗关闭事件
     */
    handlePopupClosed() {
      console.log("弹窗关闭，hasAgreed=", this.hasAgreed);
      // 将用户是否已同意的信息传递给父组件
      this.$emit("popup-closed", { hasAgreed: this.hasAgreed });
      // 注意：不在这里重置hasAgreed，而是在下次显示弹窗时重置
    },

    /**
     * 处理点击覆盖层事件
     */
    handleOverlayClick() {
      console.log("点击了弹窗背景覆盖层");
      // 不做特殊处理，使用默认关闭行为
    },

    /**
     * 处理点击关闭图标事件
     */
    handleCloseIconClick() {
      console.log("点击了弹窗关闭图标");
      // 不做特殊处理，使用默认关闭行为
    }
  }
};
</script>

<style lang="less" scoped>
.agreement-link {
  color: #1e80ff;
  text-decoration: none;
}

.agreement-popup {
  padding: 20px;

  .agreement-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding: 15px 0;
    margin-bottom: 10px;
    color: #333;
    border-bottom: 1px solid #f2f2f2;
    position: relative;
  }

  .agreement-content {
    padding: 40px 25px 0px 25px;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    max-height: calc(60vh - 140px);
    overflow-y: auto;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    text-align: justify;

    .agreement-subtitle {
      font-weight: bold;
      font-size: 15px;
      margin-bottom: 15px;
      color: #222;
    }

    p {
      margin-bottom: 12px;
    }

    .agreement-section {
      margin: 15px 0;
      background-color: #f9f9f9;
      border-radius: 8px;
      padding: 15px;

      .section-item {
        display: flex;
        margin-bottom: 12px;

        .section-num {
          color: #ffaa0a;
          margin-right: 8px;
          font-weight: bold;
          flex-shrink: 0;
        }
      }
    }

    .agreement-note {
      font-size: 13px;
      color: #666;
      font-style: italic;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px dashed #eee;
    }
  }

  .agreement-btn {
    width: 80%;
    max-width: 300px;
    height: 44px;
    line-height: 44px;
    background-color: #ffaa0a;
    color: white;
    text-align: center;
    border-radius: 22px;
    margin: 40px auto;
    font-size: 16px;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(255, 170, 10, 0.3);
    transition: all 0.3s;
    cursor: pointer;
    // 定位到协议内容下方
    position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;
    margin: 0 auto;

    @media screen and (max-width: 768px) {
      width: 90%;
      font-size: 15px;
      height: 42px;
      line-height: 42px;
    }

    &:active {
      background-color: darken(#ffaa0a, 5%);
      transform: translateY(1px);
      box-shadow: 0 1px 2px rgba(255, 170, 10, 0.3);
    }
  }
}
</style>
